import { useSelector } from 'react-redux';
import { resolveAdvisorPrefillPolicy } from '@shared';
import { selectFeatureFlags } from '@/model/selectors';

export function useAdvisorPrefillPolicy() {
  const featureFlags = useSelector(selectFeatureFlags);
  return resolveAdvisorPrefillPolicy(featureFlags);
}

export function useIsPerClientInviteLinkEnabled() {
  return useAdvisorPrefillPolicy().enabled;
}
